/**
 * P1's own starter suggestions: only what the core assistant can do on its
 * own (general questions, its release notes via `whats_new`, `web_search`,
 * and `search_crm_companies` on the CRM pages, which are gated by the CRM
 * read permission that tool needs). Everything domain-specific (quotes,
 * templates, planning, …) is registered by its package in `registry.ts`.
 */
import { defineAgentStarter, onRoutes } from "./agentStarters.js";

export const coreAgentStarters = [
  defineAgentStarter({
    id: "core.crm-company-search",
    ns: "Assistant",
    textKey: "Show me the contacts in Berlin",
    match: onRoutes("/crm/*"),
  }),
  defineAgentStarter({
    id: "core.capabilities",
    ns: "Assistant",
    textKey: "What can you help me with?",
    order: 10,
  }),
  defineAgentStarter({
    id: "core.whats-new",
    ns: "Assistant",
    textKey: "What's new in the assistant?",
    order: 20,
  }),
  defineAgentStarter({
    id: "core.web-search",
    ns: "Assistant",
    textKey: "Search the web for the current heat pump subsidies",
    order: 30,
  }),
];
